<template>
  <div class="h-screen overflow-hidden flex flex-col">
    <ui-header />

    <div class="overflow-y-auto w-full flex-1 flex flex-col">
      <ui-breadcrumb padding v-if="breadcrumb.length" :elements="breadcrumb" />

      <generic-template-header v-if="title" :title="title">
        <slot name="header" />
      </generic-template-header>

      <div class="flex-1 pt-8 pb-15">
        <div class="auto-padding" v-if="fluid">
          <slot />
        </div>
        <div v-else>
          <slot />
        </div>
      </div>
      <div>
        <ui-footer />
      </div>
    </div>
  </div>
</template>

<script>
import UiFooter from "@/components/ui/uiFooter.vue";
import uiHeader from "@/components/ui/uiHeader.vue";
import UiBreadcrumb from "@/components/ui/uiBreadcrumb.vue";
import GenericTemplateHeader from "./GenericTemplateHeader.vue";
export default {
  components: { uiHeader, UiFooter, UiBreadcrumb, GenericTemplateHeader },
  props: {
    fluid: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
    },
    breadcrumb: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.content-size {
  height: calc(100% - (67px));
}
</style>